import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { useState } from 'react'; 
import Home from './components/Home/Home';
import Nav from './components/Nav/Nav.jsx';
import Menu from './components/Menu/Menu.jsx';
import Footer from './components/Footer/Footer'
import Gallery from './components/Gallery/Gallery';
function App() { 

  const [menuOpen, setMenuOpen] = useState(false);
  const [projects, setProjects] = useState([]); 
  const [services, setServices] = useState([]);

  const [testimonials, setTestimonials] = useState([]);
  
  return (
    <div className="app-container" >
      <Nav menuOpen={menuOpen} setMenuOpen={setMenuOpen}/>
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/gallery' element={<Gallery/>} />
        </Routes>
      </BrowserRouter>
      <Footer/>
    </div>
  );
}

export default App;
